import React from 'react';
import type { PaymentSettings } from '../../types/settings';

interface PaymentSettingsProps {
  settings: PaymentSettings;
  onSave: (data: PaymentSettings) => void;
  isLoading: boolean;
}

const PaymentSettings: React.FC<PaymentSettingsProps> = ({
  settings,
  onSave,
  isLoading
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    
    const data: PaymentSettings = {
      defaultDueDays: parseInt(formData.get('defaultDueDays') as string),
      lateFees: {
        percentage: parseFloat(formData.get('lateFeesPercentage') as string),
        amount: parseFloat(formData.get('lateFeesAmount') as string)
      },
      blockCustomerAfterDays: parseInt(formData.get('blockCustomerAfterDays') as string),
      recurringBillsEnabled: formData.get('recurringBillsEnabled') === 'true'
    };

    onSave(data);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-900 mb-4">
          Configurações de Prazos e Pagamentos
        </h2>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Prazo Padrão para Vencimento (dias)
            </label>
            <input
              type="number"
              name="defaultDueDays"
              defaultValue={settings.defaultDueDays}
              min="0"
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Multa por Atraso (%)
            </label>
            <input
              type="number"
              name="lateFeesPercentage"
              defaultValue={settings.lateFees.percentage}
              min="0"
              step="0.01"
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Multa por Atraso (R$)
            </label>
            <input
              type="number"
              name="lateFeesAmount"
              defaultValue={settings.lateFees.amount}
              min="0"
              step="0.01"
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Bloquear Cliente Após (dias de atraso)
            </label>
            <input
              type="number"
              name="blockCustomerAfterDays"
              defaultValue={settings.blockCustomerAfterDays}
              min="0"
              required
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </div>

        <div className="mt-6">
          <div className="flex items-center">
            <input
              type="checkbox"
              name="recurringBillsEnabled"
              defaultChecked={settings.recurringBillsEnabled}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label className="ml-2 block text-sm text-gray-900">
              Habilitar contas recorrentes
            </label>
          </div>
        </div>
      </div>

      <div className="flex justify-end space-x-4">
        <button
          type="button"
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        >
          Restaurar Padrões
        </button>
        <button
          type="submit"
          disabled={isLoading}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {isLoading ? 'Salvando...' : 'Salvar Alterações'}
        </button>
      </div>
    </form>
  );
};

export default PaymentSettings;